// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__mAkmt","header":"ReportDetails_header__2IT59","title":"ReportDetails_title__22Ma9","left":"ReportDetails_left__2uMjO"};